import { Schema, arrayOf } from 'normalizr'

export const county = new Schema('counties')
export const arrayOfCounties = arrayOf(county)
